export default "__VITE_ASSET__leanuS3U__"